/**
 * Global notification center object. For now it's just a Foundation.Observable
 * but might become something more later.
 * @constructor
 * @extends {Foundation.Observable}
 */
Foundation.NotificationCenter = function () {
  Foundation.Observable.call(this);
};
Foundation.inherit(Foundation.NotificationCenter, Foundation.Observable);

/**
 * @return {Foundation.NotificationCenter}
 */
Foundation.NotificationCenter.sharedNotificationCenter = function () {
  if (!Foundation.NotificationCenter._sharedNoficationCenterInstance) {
    Foundation.NotificationCenter._sharedNoficationCenterInstance = new Foundation.NotificationCenter();
  }
  return Foundation.NotificationCenter._sharedNoficationCenterInstance;
};

window["Foundation"]["NotificationCenter"] = Foundation.NotificationCenter;
window["Foundation"]["NotificationCenter"]["sharedNotificationCenter"] = Foundation.NotificationCenter.sharedNotificationCenter;
